// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1ncxX","content":"styles_content__cdTjc","selectAll":"styles_selectAll__35Kjh"};